import Page from "../common/page";
import Parallax from "../common/parallax";
import MotionScrollBox from "../lib/motion-scroll-box";
import MotionScrollProduct from "../lib/motion-scroll-product";

export default class PageCalibrationRitual extends Page {
   setPage() {
       new Parallax(
            [
                {el: '.sec-2 article', tX:0, tY:()=>{
                    return window.innerHeight/8 *-1;
                    }, tS:1}
            ]
       );

        new MotionScrollProduct(
           this.el.querySelector('.sec-6 .component-scroll-holder')
       );
   }
}
